import { Dispatch } from 'redux';

import * as constants from '../constants';
import AppLogger from '../utils/logging';
const logger = AppLogger.createLogger();

export interface AddServerError {
    type: constants.ADD_SERVER_ERROR;
    payload: number;
}
export type ErrorAction = AddServerError;

export function addServerError(status: number = 500) {
    logger.error('addServerError');
    return {
        type: constants.ADD_SERVER_ERROR,
        payload: status,
    } as AddServerError;
}
